const desktopNavigation = "(min-width: 48rem)";

export function initHeaders(root = document) {
  const media = window.matchMedia(desktopNavigation);
  const menus = [...root.querySelectorAll(".est-header-menu")];

  const sync = () => {
    for (const menu of menus) {
      menu.open = media.matches;
    }
  };

  sync();
  media.addEventListener("change", sync);
}
